import { render } from "./FiscalizacaoEstagiarios.vue?vue&type=template&id=43ff3da8"
import script from "./FiscalizacaoEstagiarios.vue?vue&type=script&lang=js"
export * from "./FiscalizacaoEstagiarios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__